export default "__VITE_ASSET__CgWhWGN2__"